import React, { useCallback } from "react";

import { faTrash } from "@fortawesome/pro-solid-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import SchemaFieldType from "@mapmycustomers/shared/enum/SchemaFieldType";
import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import { Button } from "@mapmycustomers/ui";

interface Props {
  expressionFields: Set<CustomField["esKey"]>;
  field: SchemaField;
  onAction?: (field: SchemaField) => void;
}
const DeleteActionButton: React.FC<Props> = ({ expressionFields, field, onAction }) => {
  const intl = useIntl();

  const handleClick = useCallback(() => {
    onAction?.(field);
  }, [field, onAction]);

  const isStandard = field.fieldType === SchemaFieldType.STANDARD;
  const isUsedInCalculation = expressionFields.has(field.field);

  return (
    <span>
      <Tooltip
        placement={isStandard ? "top" : "bottom"}
        title={
          isUsedInCalculation
            ? intl.formatMessage({
                id: "settings.manageFields.grid.actions.delete.disabled.calculatedField",
                defaultMessage: "Fields that contribute to a calculated field cannot be deleted",
                description: "Header of disabled (calculated field) Delete Field action",
              })
            : isStandard
            ? intl.formatMessage({
                id: "settings.manageFields.grid.actions.delete.disabled",
                defaultMessage: "Deletion of standard fields is not permitted",
                description: "Header of disabled Delete Field action",
              })
            : intl.formatMessage({
                id: "settings.manageFields.grid.actions.delete",
                defaultMessage: "Delete Permanently",
                description: "Header of Delete Field action",
              })
        }
      >
        <Button
          disabled={isStandard || isUsedInCalculation}
          icon={<FontAwesomeIcon icon={faTrash} />}
          iconOnly
          onClick={handleClick}
          type="text"
        />
      </Tooltip>
    </span>
  );
};

export default DeleteActionButton;
